export const isInIframe =
  'location' in globalThis &&
  new URL(globalThis.location.href).searchParams.get('iframe') === 'true';
